import React from "react";
import PropTypes from "prop-types";
import { Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import {
  GroupingState,
  IntegratedGrouping,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from "@devexpress/dx-react-grid";
import {
  Grid,
  Table,
  TableGroupRow,
  TableHeaderRow,
} from "@devexpress/dx-react-grid-material-ui";

import "./gridStyles.css"; // Import your custom CSS file

const useStyles = () => ({
  headerblack: {
    color: "red",
  },
  headerblue: {
    color: "blue",
  },
});

const HeaderCell = ({ ...restProps }) => (
  <TableHeaderRow.Cell
    {...restProps}
    style={{
      fontWeight: "bold",
      paddingTop: 5,
      paddingBottom: 5,
      fontSize: "16px",
    }}
  />
);

// eslint-disable-next-line react/prop-types, no-unused-vars
const CustomRow = ({ style, ...restProps }) => (
  <Table.Cell
    {...restProps}
    style={{
      // Adjust the row height as needed
      paddingTop: 10,
      paddingBottom: 10,
      whiteSpace: "break-spaces",
      // Adjust the top and bottom padding as needed
    }}
  />
);

const CustomDataGrid = (props) => {
  return (
    <>
      <Paper
        style={{
          width: "98%",
          marginLeft: "1%",
          marginTop: "0.5%",
          marginBottom: 8,
        }}
      >
        <Grid rows={props.rows} columns={props.columns}>
          <SortingState />

          <GroupingState />
          <PagingState />

          <IntegratedGrouping />

          <IntegratedSorting />
          <IntegratedPaging />

          <Table cellComponent={CustomRow} />
          <TableHeaderRow
            style={{ padding: 1 }}
            showSortingControls={true}
            cellComponent={HeaderCell}
          />

          <TableGroupRow />
        </Grid>
      </Paper>
    </>
  );
};

CustomDataGrid.propTypes = {
  classes: PropTypes.object,
  columns: PropTypes.array,
  rows: PropTypes.array,
  pageSizes: PropTypes.array,
  currencyColumns: PropTypes.array,
};

CustomDataGrid.defaultProps = {
  classes: {},
  columns: [],
  rows: [],
  pageSizes: [],
  currencyColumns: [],
};

export default withStyles(useStyles)(CustomDataGrid);
